module.exports = __webpack_public_path__ + "static/dashboard-report-icon-99314845c9233f25a8836ba2474aa94d.png";